var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.45 1a6.484 6.484 0 015.135 2.552c.229-.184.469-.364.719-.542 1.747-1.242 3.45-1.972 5.235-1.966a6.489 6.489 0 014.57 1.904 6.442 6.442 0 011.907 4.593 6.355 6.355 0 01-1.876 4.528h0l-9.862 9.842-10.37-9.92A6.446 6.446 0 011 7.396a6.35 6.35 0 011.873-4.524A6.482 6.482 0 017.451 1z",
    fillRule: "nonzero",
    stroke: "#3CDBC0",
    strokeWidth: 2,
    fill: "none"
  })));
}
export default SvgHeartAlt;